import React from 'react';
import LayoutLogin from '../../layouts/layout_login';
import { Alert, Button, Card, Form, Input, Space, theme } from 'antd';
import { useAppDispatch, useAppSelector } from '../../hook';
import { clearResult, login } from './_slice';
import { useNavigate, useSearchParams } from 'react-router-dom';

interface ILoginPageProps {
}

const LoginPage: React.FC<ILoginPageProps> = () => {
  const [form] = Form.useForm();
  const { token } = theme.useToken();
  const loginState = useAppSelector((state) => state.login);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    borderRadius: token.borderRadiusLG,
    padding: 0,
  };

  const onLogin = async (values: any) => {
    const dispatchResult = await dispatch(login({apiKey: values.apiKey}));
    const customerCount = dispatchResult.payload as number;
    if (customerCount === 1) {
      // After logging in successfully, should redirect to `/devices` if no `from` path
      navigate(searchParams.get('from') || '/devices', { replace: true });
    } else if (customerCount > 1) {
      // After logging in successfully, should redirect to `/` if no `from` path
      navigate(searchParams.get('from') || '/', { replace: true });
    }
  }

  return (
    <LayoutLogin>
      <Card title="Login PiP IoT" variant="borderless">
        <Form form={form} name="login" style={formStyle} onFinish={onLogin}>
          <Form.Item
            label="API Key"
            name="apiKey"
            rules={[{ required: true, message: 'Please input PIP API key!' }]}
          >
            <Input.TextArea style={{ height: 100 }}/>
          </Form.Item>
          
          <div style={{ textAlign: 'right' }}>
            <Space size="small">
              <Button
                  onClick={() => {
                    form.resetFields();
                    dispatch(clearResult());
                  }}
                >
                Clear
              </Button>
              <Button type="primary" htmlType="submit" style={{ width: 120 }}>
                Login
              </Button>
            </Space>
          </div>
        </Form>
        {loginState.isLoggingIn && <Alert message="Logging in..." type="info" showIcon style={{ marginTop: 10 }}/>}
        {loginState.errMsg && <Alert message={loginState.errMsg} type="error" showIcon style={{ marginTop: 10 }}/>}
      </Card>
    </LayoutLogin>
  );
};

export default LoginPage;